import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-demande-service-description-card",
  templateUrl: "./demande-service-description-card.component.html",
  styleUrls: ["./demande-service-description-card.component.scss"],
})
export class DemandeServiceDescriptionCardComponent {
  @Input() description = "";
  @Input() descriptionLength = 0;
  @Input() placeholder = "";

  @Output() valueChange = new EventEmitter<string>();
  @Output() inputFocus = new EventEmitter<void>();
  @Output() inputBlur = new EventEmitter<void>();
}
